<template>
  <div class="flex act-container">
    <div class="lt_bg">
      <act-preview
        navigationBg="#F72727"
        phoneHeaderFixedColor="#fff"
        navigationTitle="接龙活动"
        phoneBodyOverflowHidden
      >
        <div slot="headerSlot">
          <div class="bg"></div>
        </div>
        <div class="slot">
          <div class="tabs flex">
            <div
              v-for="(v, i) in activitiesList"
              :key="i"
              class="tab"
              :class="{ active: i === 0 }"
            >
              {{ v.name }}
            </div>
          </div>
          <div
            class="header-img-wrapper"
            :class="{ 'prev-upload': type !== 'detail' }"
          >
            <img
              class="header-img"
              v-if="ruleForm.gameBgp"
              :src="ruleForm.gameBgp"
              alt=""
            />
          </div>

          <div class="preview-container flex">
            <el-scrollbar :vertical="false" wrap-style="height: 360px;">
              <div class="act-info-wrapper">
                <div
                  v-for="(v, i) in ruleForm.setRuleModelList"
                  :key="i"
                  class="second-tabs"
                >
                  <div
                    class="second-tab flex flex-center item-center"
                    @click="switchTab(v)"
                    :class="{ active: activeTab === v.areaName }"
                  >
                    <div style="line-height: 20px">
                      <p class="area-name">{{ v.areaName }}</p>
                      <p class="area-num" v-if="v.areaNum">0/{{ v.areaNum }}</p>
                    </div>
                  </div>
                </div>
              </div>
            </el-scrollbar>
            <el-scrollbar
              :vertical="false"
              wrap-style="height: 360px;background: #fff;"
              class="flex-1"
            >
              <div class="act-info-goods">
                <div
                  v-for="(v, i) in goodsRuleModelList"
                  :key="i"
                  class="flex mb20"
                >
                  <div style="width: 50px" class="flex item-center flex-center">
                    <div class="radio"></div>
                  </div>
                  <el-image
                    style="width: 80px; height: 80px; border-radius: 5px"
                    :src="v.spuMainPic"
                    fit="fit"
                  ></el-image>
                  <div class="flex-1 flex flex-column flex-between p10">
                    <div class="goods-name">
                      {{ v.wxshopSpuName }}
                    </div>
                    <div class="primary">
                      <span>¥</span> {{ v.wxshopPrice }}
                    </div>
                  </div>
                </div>
              </div>
            </el-scrollbar>
          </div>
          <div class="flex flex-between item-center bottom">
            <div class="cart">
              <img
                src="https://imgcdn.hemiao100.com/ThemePictures/%E7%BC%96%E7%BB%84%207%402x.png"
                alt=""
              />
            </div>
            <div class="submit">提交订单</div>
          </div>
        </div>
      </act-preview>
    </div>

    <div class="add-goods-container">
      <div class="act-wrapper">
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="130px"
        >
          <el-form-item label="活动名称：" prop="gameName">
            <el-input
              :disabled="copyJieLong"
              style="width: 400px"
              size="small"
              clearable
              class="mr10 ipt"
              v-model.trim="ruleForm.gameName"
              placeholder="请输入活动名称(100字以内)"
              maxlength="100"
            ></el-input>
          </el-form-item>

          <el-form-item label="活动时间：" prop="activityDate">
            <el-date-picker
              :disabled="copyJieLong"
              v-model="ruleForm.activityDate"
              type="datetimerange"
              align="right"
              ref="applyDatePicker"
              :picker-options="pickerOptions"
              start-placeholder="报名开始时间"
              end-placeholder="报名结束时间"
              value-format="yyyy-MM-dd HH:mm:ss"
              size="small"
              class="mr10"
              :default-time="['00:00:00', '23:59:59']"
            ></el-date-picker>
          </el-form-item>

          <el-form-item label="促销标签：">
            <el-tag
              :key="tag"
              v-for="tag in ruleForm.activityLabels"
              closable
              :disable-transitions="false"
              @close="handleClose(tag)"
              >{{ tag }}</el-tag
            >
            <el-input
              :disabled="copyJieLong"
              class="input-new-tag"
              v-if="inputVisible"
              v-model.trim="inputValue"
              ref="saveTagInput"
              size="small"
              maxlength="10"
              clearable
              placeholder="请输入标签，在10个汉字以内"
              @keyup.enter.native="handleInputConfirm"
              @blur="handleInputConfirm"
            ></el-input>
            <el-button
              :disabled="copyJieLong"
              v-else
              class="button-new-tag"
              size="small"
              @click="showInput"
              >+ 新标签</el-button
            >
          </el-form-item>

          <!-- <el-form-item label="活动分享文案" prop="gameShareContent">
            <el-input
              :maxlength="30"
              style="width: 400px"
              size="small"
              clearable
              class="mr10 ipt"
              v-model.trim="ruleForm.gameShareContent"
              placeholder="请输入活动分享文案，30字以内"
            ></el-input>
          </el-form-item> -->
          <el-form-item label="背景图：" prop="mainImgUrl">
            <my-upload
              field="file"
              @crop-success="cropSuccess"
              @crop-upload-success="cropUploadSuccess"
              @crop-upload-fail="cropUploadFail"
              v-model="show"
              v-if="show"
              noCircle
              noSquare
              :width="750"
              :height="280"
              :headers="{ 'X-Access-Token': $token }"
              :params="{ fileDir: 'mallDecoration' }"
              :url="$uploadUrl"
              img-format="png"
            ></my-upload>
            <el-button
              type="primary"
              size="small"
              v-show="!listHeaderImgUrl"
              @click="toggleShow"
              >上传</el-button
            >
            <span class="form-tip"
              >图片尺寸建议750x280（最多上传一张）</span
            >
            <div class="priview" v-if="listHeaderImgUrl">
              <img :src="listHeaderImgUrl" alt="主图" />
              <div class="opreat-wrapper flex item-center flex-center">
                <el-button type="text" @click="toggleShow"
                  >更换</el-button
                >
              </div>
            </div>
          </el-form-item>
          <!-- <el-form-item label="分享图：">
            <el-upload
              class="upload flex"
              ref="eluploadMainPic"
              :limit="1"
              drag
              :data="{ fileDir: 'mall' }"
              :headers="{ 'X-Access-Token': $token }"
              :action="$uploadUrl"
              :onSuccess="uploadSharePicSucc"
              :beforeUpload="beforeUpload"
              :onProgress="uploading"
              :show-file-list="uploadShow"
              v-if="!ruleForm.sharePic"
            >
              <i class="el-icon-upload"></i>
              <div class="el-upload__text">
                将图片拖到此处，或
                <em>点击上传</em>
              </div>
              <div class="el-upload__tip" slot="tip">
                <div class="ml10">
                  上传图片注意：
                  <div>
                    1.分享图仅可设置一张
                  </div>
                  <div>
                    2.图片尺寸建议500x400
                  </div>
                </div>
              </div>
            </el-upload>
            <div class="priview priviewSharePic" v-if="ruleForm.sharePic">
              <img :src="ruleForm.sharePic" alt="分享图" />
              <div class="opreat-wrapper flex item-center flex-center">
                <el-button type="text" @click="handleRemoveSharePic">删除</el-button>
              </div>
            </div>
          </el-form-item> -->

          <el-form-item label="活动内容：" prop="gameRuleRemark">
            <span class="form-tip">1.上传图片建议是7:6的比例，大小不超过1M，多个图片请分开上传</span><br>
            <span class="form-tip">2.如果图片超过6张，分享商品时会自动生成6宫格，低于6张则只有1张大图</span>
            <hm-rich-editor
              :html="ruleForm.gameRuleRemark"
              v-model="ruleForm.gameRuleRemark"
            />
          </el-form-item>

          <div>
            <el-button
              :disabled="copyJieLong"
              style="float: left"
              @click="addGoods"
              type="primary"
              size="small"
              >添加商品
            </el-button>
            <el-form-item
              style="float: right"
              label="佣金是否开启"
              prop="commissionState"
            >
              <el-switch
                :disabled="copyJieLong"
                v-model="ruleForm.commissionState"
                active-text="显示"
                inactive-text="隐藏"
                active-value="yes"
                active-color="#13ce66"
                inactive-value="no"
              ></el-switch>
            </el-form-item>
          </div>
          <!--添加商品 -->
          <div>
            <el-table
              :data="ruleForm.jielongGoodsRuleModelList"
              row-key="wxshopSkuId"
              border
              stripe
              height="500"
              style="width: 100%"
            >
              <el-table-column type="index" label="序号" width="50">
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="goodsSn"
                label="商品货号"
              >
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="wxshopSpuName"
                label="商品名称"
                :show-overflow-tooltip="true"
              >
              </el-table-column>

              <el-table-column
                header-align="center"
                align="center"
                prop="specIdGroupName"
                label="商品规格"
                :show-overflow-tooltip="true"
              >
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="singleLimit"
                label="单人限购"
                width="122"
              >
                <template slot="header">
                  <el-popover
                    placement="top-start"
                    title="提示"
                    width="200"
                    trigger="hover"
                    content="单人限购为必填"
                  >
                    <div slot="reference">单人限购</div>
                  </el-popover>
                </template>
                <template slot-scope="scope">
                  <el-input
                    :disabled="copyJieLong || copyJieLong"
                    maxlength="30"
                    @mousewheel.prevent.native
                    style="width: 80px"
                    v-model.trim="scope.row.singleLimit"
                    size="small"
                    @input="filterGt0OrFixed0('singleLimit', scope.$index)"
                    clearable
                  ></el-input>
                </template>
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="totalStockSum"
                label="活动库存"
                width="150"
              >
                <template slot="header">
                  <el-popover
                    placement="top-start"
                    title="提示"
                    width="200"
                    trigger="hover"
                    content="活动库存为必填"
                  >
                    <div slot="reference">活动库存</div>
                  </el-popover>
                </template>
                <template slot-scope="scope">
                  <el-input
                    :disabled="copyJieLong || copyJieLong"
                    maxlength="30"
                    @mousewheel.prevent.native
                    style="width: 100px"
                    v-model.trim="scope.row.totalStockSum"
                    size="small"
                    @input="filterGt0OrFixed0('totalStockSum', scope.$index)"
                    clearable
                    placeholder="活动库存"
                  ></el-input>
                </template>
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="wxshopPrice"
                label="零售价"
                style="width: 80px"
                :show-overflow-tooltip="true"
              >
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="activityPrice"
                label="接龙价"
              >
                <template slot-scope="scope">
                  <el-input
                    :disabled="copyJieLong || copyJieLong"
                    maxlength="30"
                    @mousewheel.prevent.native
                    style="width: 80px"
                    v-model.trim="scope.row.activityPrice"
                    size="small"
                    @input="filterGt0OrFixed2('activityPrice', scope.$index)"
                    clearable
                  ></el-input
                  >元
                </template>
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="seqNum"
                label="主图排序"
              >
                <template slot-scope="scope">
                  <el-select size="small" style="width: 80px" clearable v-model="scope.row.seqNum" placeholder="请选择">
                    <el-option
                      v-for="item in [1,2,3,4]"
                      :key="item"
                      :value="item">
                    </el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column
                v-if="commissionState === 'yes'"
                header-align="center"
                align="center"
                prop="virtualExchangeNum"
                label="佣金"
              >
                <template slot-scope="scope">
                  <el-input
                    :disabled="copyJieLong"
                    maxlength="30"
                    @mousewheel.prevent.native
                    style="width: 80px"
                    v-model.trim="scope.row.virtualExchangeNum"
                    size="small"
                    @input="
                      filterGt0OrFixed0('virtualExchangeNum', scope.$index)
                    "
                    clearable
                  ></el-input>
                </template>
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                label="操作"
                width="70px"
                v-if="type !== 'details'"
              >
                <template slot-scope="scope">
                  <div class="minus-wrapper flex flex-center">
                    <span
                      class="hmicon icon-jianhao pointer"
                      @click="deleteGoodChild(scope.$index, scope.row)"
                    ></span>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>

          <el-form-item label="接龙信息表单：" prop="formStatus">
            <el-radio-group
              v-model="ruleForm.formStatus"
              :disabled="copyJieLong"
            >
              <el-radio label="open">开启</el-radio>
              <el-radio label="close">关闭</el-radio>
            </el-radio-group>
            <hm-form
              :disabled="copyJieLong"
              ref="hmform"
              v-if="ruleForm.formStatus === 'open'"
            >
            </hm-form>
          </el-form-item>

          <el-form-item label="开启接龙促销：" prop="usePromotion" v-if="isShowPromotion">
            <el-radio-group
              v-model="ruleForm.usePromotion"
              :disabled="changeTeam"
            >
              <el-radio label="yes">开启</el-radio>
              <el-radio label="no">关闭</el-radio>
            </el-radio-group>
            <div v-if="ruleForm.usePromotion==='yes'">
            <div class="caption">
              <span class="mr10">促销内容</span>
              <span class="primary activity">({{ childTypeName }})</span>
            </div>
            <div class="way">
              <div class="flex"  v-if="!changeTeam">
                <div class="title">优惠方式</div>
                <div class="way-list">
                  <div class="flex way-item">
                    <div class="item mr20">
                      买满
                      <el-input
                        v-model="calcCondition"
                        @input="filterGt0OrFixed2('calcCondition')"
                        type="number"
                        :disabled="changeTeam"
                      ></el-input>
                      <span v-if="childId === 'PriceReduction'">元</span>
                      <span v-if="childId === 'NumReduction'">件</span>
                    </div>
                    <div class="item mr20">
                      立减
                      <el-input
                        v-model="discountResult"
                        @input="filterGt0OrFixed2('discountResult')"
                        type="number"
                        :disabled="changeTeam"
                      ></el-input
                      >元
                    </div>
                    <!-- <div class="item mr20">
                      最多循环
                      <el-input
                        v-model="cyclesTimes"
                        @input="filterGt0('cyclesTimes')"
                        type="number"
                      ></el-input
                      >次
                    </div> -->
                    <div class="add-wrapper" v-show="jielongFullReductionRuleModelList.length == 0">
                      <span
                        class="hmicon icon-hao pointer"
                        @click="addItem('jielongFullReductionRuleModelList')"
                        :disabled="jielongFullReductionRuleModelList.length >= 20"
                      ></span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="flex">
                <div class="title">已选优惠</div>
                <div class="way-list">
                  <div
                    class="flex way-item item-center"
                    v-for="(v, i) in jielongFullReductionRuleModelList"
                    :key="i"
                  >
                    <div class="item mr20">
                      买满
                      <span class="primary">{{ v.calcCondition }}</span>
                      <span v-if="childId === 'PriceReduction'">元</span>
                      <span v-if="childId === 'NumReduction'">件</span>
                    </div>
                    <div class="item mr20">
                      立减
                      <span class="primary">{{ v.discountResult }}</span
                      >元
                    </div>
                    <!-- <div class="item mr20">
                      最多循环
                      <span class="primary">{{ v.cyclesTimes }}</span
                      >次
                    </div> -->
                    <div class="item mr20" v-if="!changeTeam">
                      <div class="minus-wrapper">
                        <span
                          class="hmicon icon-jianhao pointer"
                          @click="deleteItem('jielongFullReductionRuleModelList', i)"
                          :disabled="changeTeam"
                        ></span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            </div>
          </el-form-item>

          <el-form-item label="配送方式限制" prop="expressModeGroups">
            <el-checkbox-group
              :disabled="copyJieLong"
              v-model="ruleForm.expressModeGroups"
            >

            <span class="title" style="display:flex;aligin-items:center; color:#666; font-size:14px; margin-right:16px;">
                选择门店：
                <div @click="outputExcelStores" class="delete pointer">
                  <span class="delete-icon hmicon icon-daochu"></span>
                  下载模板
                </div>
                <div class="delete mr20 pointer open-file" style="margin-left:20px;">
                  <span class="delete-icon hmicon icon-daoru"></span>
                  导入
                  <input
                      type="file"
                      @change="importfStore"
                      accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                  />
                </div>
              </span>


              <div>
                <el-checkbox label="shop_extract">门店自提</el-checkbox>
                <el-select
                    class="ml10"
                    clearable
                    multiple
                    v-model="ruleForm.shopIds"
                    placeholder="请选择可销售门店"
                    size="small"
                    filterable
                    @change="getCheckedStore"
                    v-if="storeCode != '53010017032439' && storeCode != '42010216070190' "
                >
                  <el-option
                      label="全部门店"
                      value="all"
                      :disabled="selectOther"
                  ></el-option>
                  <el-option
                      :disabled="selectAll"
                      :label="v.shopName"
                      :value="v.shopId"
                      v-for="(v, i) in microShopStoreList"
                      :key="i"
                  ></el-option>
                </el-select>
                <el-select
                    class="ml10"
                    clearable
                    multiple
                    v-model="ruleForm.shopIds"
                    placeholder="请选择可销售门店"
                    size="small"
                    filterable
                    @change="getCheckedStore"
                    v-if="storeCode === '53010017032439' || storeCode === '42010216070190' "
                >
                  <el-option
                      label="全部门店"
                      value="all"
                      :disabled="selectOther"
                  ></el-option>
                  <el-option
                      :disabled="selectAll"
                      :label="v.shopName"
                      :value="v.shopId"
                      v-for="(v, i) in dkMicroShopStoreList"
                      :key="i"
                  ></el-option>
                </el-select>
              </div>
              <div>
                <el-checkbox label="express_delivery">快递物流</el-checkbox>
                <el-select
                  :disabled="copyJieLong"
                  size="small"
                  v-model="ruleForm.expressId"
                  filterable
                  class="ml10"
                  clearable
                  placeholder="请选择运费模板"
                >
                  <el-option
                    :label="v.expressName"
                    :value="v.expressId"
                    v-for="(v, i) in expressList"
                    :key="i"
                  ></el-option>
                </el-select>
              </div>
            </el-checkbox-group>
          </el-form-item>

          <div class="flex flex-center">
            <el-button
              :disabled="copyJieLong"
              type="primary"
              size="small"
              @click="submitForm('ruleForm')"
              >提交</el-button
            >
            <el-button size="small" @click="$router.back(-1)">返回</el-button>
          </div>
        </el-form>
      </div>
    </div>

    <hm-filter-m-s-goods
      type="microShop"
      :visible="dialogVisible"
      :radio="isRadio"
      @saveGoods="saveGoods"
      @setLink="setLink"
      @close="dialogVisible = false"
    ></hm-filter-m-s-goods>
  </div>
</template>

<script>
import { setCookie, getCookie, queryActivityCategory } from "../../utils/utils";
import HmFilterMSGoods from "@/components/HmFilterMSGoods";
import { arrayUnique2 } from "@/utils/utils";
import myUpload from "vue-image-crop-upload";
import HmRichEditor from "@/components/HmRichEditor";
import HmForm from "@/components/HmForm2";
import actPreview from "@/components/actPreview";
import { mapGetters } from "vuex";
import {getLoginUser} from "@/utils/auth";
let wb; // 读取完成的数据
let rABS = false; // 是否将文件读取为二进制字符串
export default {
  components: {
    myUpload,
    HmRichEditor,
    HmForm,
    actPreview,
    HmFilterMSGoods
  },
  data() {
    const patterndRuleFunc = (rule, val, callback) => {
      let falg = false;
      this.ruleForm.jielongGoodsRuleModelList.forEach(v => {
        if (
          v.totalStockSum === "" ||
          v.singleLimit === "" ||
          v.activityPrice === ""
        ) {
          falg = true;
        }
        if (falg) {
          return callback(new Error("请输入必填项"));
        }
      });
      callback();
    };

    const expressModeGroupsStatus = (rule, val, callback) => {
      if (val.findIndex(v => v === "shop_extract") > -1) {
        if (!this.ruleForm.shopIds.length) {
          return callback(new Error("请选择可销售门店"));
        }
      }
      if (val.findIndex(v => v === "express_delivery") > -1) {
        if (!this.ruleForm.expressId) {
          return callback(new Error("请选择运费模板"));
        }
      }

      callback();
    };
    const patternFormStatus = (rule, val, callback) => {
      if (val === "open") {
        if (this.$refs.hmform.list.length === 0) {
          return callback(new Error("请选择表单"));
        } else {
          let flag = false;
          this.$refs.hmform.list.forEach(v => {
            if (v.columnValue === "") {
              flag = true;
            }
            if (v.columnType === "radio") {
              v.paramInfoModels.forEach(o => {
                if (o.columnValue === "") {
                  flag = true;
                }
              });
            }
          });
          if (flag) {
            return callback(new Error("请把表单填写完整"));
          }
        }
      }
      callback();
    };
    const patterndMainImgUrlFunc = function(rule, val, callback) {
      if (!this.listHeaderImgUrl) {
        return callback(new Error("请选择主图"));
      }
      callback();
    }.bind(this);
    return {
      storeCode: "",
      selectOther: false,
      selectAll: false,
      expressList: [],
      tagsNum: 0,
      isRadio: false,
      dialogVisible: false,
      value: "",
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7;
        }
      },
      inputVisible: false,
      inputValue: "",
      activeTab: 0,
      type: 0,
      uploadedDetailList: [],
      listHeaderImgUrl: "https://imgcdn.hemiao100.com//hemiaoBase/jielong/bg.jpg",
      storeId: "",
      startDate: "",
      validDate: "",
      editorOption: {},
      chargeType: "",
      ruleForm: {
        activityLabels: [],
        gameName: "",
        activityDate: [],
        gameRuleRemark: "",
        formStatus: "open",
        jielongGoodsRuleModelList: [],
        expressModeGroups: [],
        deliverMoney: 0,
        commissionState: "no",
        shopIds: [],
        expressId: "",
        columnsInfoModels: [],
        gameShareContent: "",
        sharePic: "",
        usePromotion: "no",
        usePromotionType: "FullReduction-PriceReduction",
      },
      commissionState: "no", // 佣金默认不开启
      rules: {
        formStatus: [
          {
            required: true,
            message: "请选择表单状态",
            trigger: "blur"
          },
          { required: true, validator: patternFormStatus, trigger: "change" }
        ],
        gameName: [
          {
            required: true,
            message: "请输入活动标题",
            trigger: "blur"
          },
          {
            min: 2,
            max: 100,
            message: "长度在 2 到 100 个字符",
            trigger: "blur"
          }
        ],
        expressModeGroups: [
          {
            required: true,
            message: "请选择配送方式限制"
          },
          {
            required: true,
            validator: expressModeGroupsStatus
          }
        ],
        activityDate: {
          required: true,
          message: "请输入活动时间",
          trigger: "blur"
        },
        gameRuleRemark: [
          { required: true, message: "请输入图文详情", trigger: "blur" }
        ],
        jielongGoodsRuleModelList: [
          {
            required: true,
            message: "请设置规则！",
            trigger: "blur"
          },
          {
            required: true,
            validator: patterndRuleFunc,
            trigger: "blur"
          }
        ],
        gameShareContent: [
          {
            required: true,
            message: "请输入活动分享文案",
            trigger: "blur"
          }
        ],
        mainImgUrl: [
          {
            required: true,
            validator: patterndMainImgUrlFunc,
            trigger: "blur"
          }
        ],
      },
      type: this.$route.query.type,
      gameId: this.$route.query.gameId,
      copyJieLong: this.$route.query.copyJieLong,
      changeTeam: this.$route.query.changeTeam,
      activitiesList: [
        {
          name: "搭配套餐"
        },
        {
          name: "宝妈专享"
        },
        {
          name: "新客特惠"
        },
        {
          name: "大牌精选"
        }
      ],
      index: 0,
      goodsRuleModelList: [],
      updateMode: "",
      columnsInfoModels: null,
      isSaving: false,
      uploadShow: true,
      show: false,
      childId: "PriceReduction",
      childTypeName: "满额减金额",
      calcCondition: "",
      discountResult: "",
      cyclesTimes: 0,
      jielongFullReductionRuleModelList: [],
      increasePurchaseResult: [],
      gameVersion: "jielongV2",
      isShowPromotion: false
    };
  },
  created() {
    this.queryTag();
  },
  mounted() {
    
    const { storeCode } = getLoginUser();
    this.storeCode = storeCode;
    console.log("this.storeCode:",this.storeCode);
    if (storeCode === '42010216070190' || storeCode === '53010017032439') {
      this.$store.dispatch("queryDkMicroStoreList");
    } else {
      this.$store.dispatch("queryMicroStoreList");
    }
    //  修改
    if (this.gameId) {
      this.queryDetails();
    }
    // 复制
    if (this.copyJieLong) {
      this.copyJieLong = true;
      console.log("copyJieLong===true", this.copyJieLong);
      this.queryDetails();
    }
    this.$store.dispatch("queryStoreStyle");
    this.queryExpressList();
    this.getParamValueAllowNull();
  },
  computed: mapGetters(["storeStyle", "microShopStoreList", "dkMicroShopStoreList"]),
  methods: {
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]));
    },
      // 导出excel
    outputExcelStores() {
      console.log('导出excel')
      require.ensure([], () => {
        const { exportJsonToExcel } = require("@/utils/output/Export2Excel");
        const tHeader = [
          "商店名称",
          "商店编码"
        ];
        const filterVal = [];
        const data = this.formatJson(filterVal, []);
        exportJsonToExcel(tHeader, data, "门店模板");
      });
    },
    // 导入excel
    importfStore(e) {
      console.log('导入excel')
      const obj = e.target;
      const that = this;
      this.inputData = [];
      if (!obj.files) {
        return;
      }
      let f = obj.files[0];
      let reader = new FileReader();
      reader.onload = async function(e) {
        let data = e.target.result;
        if (rABS) {
          wb = XLSX.read(btoa(this.fixdata(data)), {
            // 手动转化
            type: "base64"
          });
        } else {
          wb = XLSX.read(data, {
            type: "binary"
          });
        }
        let result = null;
        wb.SheetNames.forEach(sheetName => {
          let roa = XLSX.utils.sheet_to_json(wb.Sheets[sheetName], {
            header: 1
          });
          if (roa.length) {
            result = roa.slice(1);
          }
        });
        const formatResult = [];
        let isRequired = true;
        result.forEach(v => {
          if (!v[0] || !v[1] ) {
            isRequired = false;
          } else {
            isRequired = true
          }
          formatResult.push({
            shopName:v[0],
            shopId:v[1]
          });
        });
        if (isRequired) {
          let arrs = []
          formatResult.forEach(v => {
            arrs.push({shopCode:v.shopId})
          });;
          const { result } = await that.$store.dispatch("importFilterShopCodeList", arrs);
          if(result && result.successShopInfoModelList){
            that.ruleForm.shopIds = result.successShopInfoModelList.map(e=>e.shopId);
          }
        } else {
          if (!isRequired) {
            that.$message({
              message: "导入失败，请导入完整商店信息！",
              type: "warning"
            });
          }
        }
      };
      if (rABS) {
        reader.readAsArrayBuffer(f);
      } else {
        reader.readAsBinaryString(f);
      }
      obj.value = "";
    },
    getCheckedStore(storeList) {
      this.selectOther = storeList.findIndex(o => o !== "all") > -1;
      this.selectAll = storeList.findIndex(o => o === "all") > -1;
      if (this.selectAll) {
        this.ruleForm.shopIds = ["all"];
      }
    },
    // 从列表页跳转过来的修改活动 gameId
    async queryDetails() {
      const { result } = await this.$store.dispatch("findJieLongInfoById", {
        gameId: this.gameId
      });
      for (let key in this.ruleForm) {
        if (this.ruleForm.hasOwnProperty(key)) {
          this.ruleForm[key] = result[key];
        }
      }
      this.ruleForm.gameRuleRemark = result.gameRuleRemark;
      this.ruleForm.activityDate = [result.gameStartTime, result.gameEndTime];
      this.listHeaderImgUrl = result.gameBgp;
      this.ruleForm.sharePic = result.gameBgp2;
      this.updateMode = result.updateMode;
      this.jielongFullReductionRuleModelList = result.jielongFullReductionRuleModelList;
      if (result && result.columnsInfoModels) {
        this.$refs.hmform.list = result.columnsInfoModels;
      }
       console.log('jielongGoodsRuleModelList',this.ruleForm.jielongGoodsRuleModelList)
       if(this.ruleForm.jielongGoodsRuleModelList.length>0){
        this.ruleForm.jielongGoodsRuleModelList.forEach(item => {
          if(item.seqNum == 0){
            item.seqNum = ''
          }
        })
       }
    },
    // 运费模板
    async queryExpressList() {
      const { result } = await this.$store.dispatch("storeExpressConfigList");
      this.expressList = [];
      if (result.defaultTemplate) {
        this.expressList.push(result.defaultTemplate);
      }
      this.expressList.push(...result.templateList);
    },
    switchTab(item) {
      this.activeTab = item.areaName;
      this.goodsRuleModelList = item.setGoodsRuleModelList;
    },
    addGoods() {
      this.dialogVisible = true;
    },
    filterGt0OrFixed2(prop, i) {
      // this.ruleForm[prop] = this.ruleForm[prop].replace(/^(0+)/, ""); //过滤0开头
      this.ruleForm.jielongGoodsRuleModelList[i][
        prop
      ] = this.ruleForm.jielongGoodsRuleModelList[i][prop].replace(
        /[^\d.]/g,
        ""
      ); //仅保留数字和"."
      this.ruleForm.jielongGoodsRuleModelList[i][
        prop
      ] = this.ruleForm.jielongGoodsRuleModelList[i][prop].replace(
        /\.{2,}/g,
        "."
      ); //两个连续的"."仅保留第一个"."
      this.ruleForm.jielongGoodsRuleModelList[i][
        prop
      ] = this.ruleForm.jielongGoodsRuleModelList[i][prop]
        .replace(".", "$#*")
        .replace(/\./g, "")
        .replace("$#*", "."); //去除其他"."
      this.ruleForm.jielongGoodsRuleModelList[i][
        prop
      ] = this.ruleForm.jielongGoodsRuleModelList[i][prop].replace(
        /^(\d+)\.(\d\d).*$/,
        "$1.$2"
      ); //限制只能输入两个小数
      if (
        this.ruleForm.jielongGoodsRuleModelList[i][prop].indexOf(".") < 0 &&
        this.ruleForm.jielongGoodsRuleModelList[i][prop] != ""
      ) {
        //首位是0的话去掉
        this.ruleForm.jielongGoodsRuleModelList[i][prop] = parseFloat(
          this.ruleForm.jielongGoodsRuleModelList[i][prop]
        );
      }
    },
    filterGt0OrFixed0(prop, i) {
      if (prop !== "activityPrice" && prop !== "virtualExchangeNum") {
        this.ruleForm.jielongGoodsRuleModelList[i][
          prop
        ] = this.ruleForm.jielongGoodsRuleModelList[i][prop].replace(
          /^(0+)/,
          ""
        ); //过滤0开头
      }

      this.ruleForm.jielongGoodsRuleModelList[i][
        prop
      ] = this.ruleForm.jielongGoodsRuleModelList[i][prop].replace(
        /[^\d]+/g,
        ""
      );
      this.ruleForm.jielongGoodsRuleModelList[i][
        prop
      ] = this.ruleForm.jielongGoodsRuleModelList[i][prop].replace(
        /\.{2,}/g,
        ""
      ); //两个连续的"."仅保留第一个"."
    },
    saveGoods(data) {
      if (data.length > 0) {
        this.dialogVisible = false;
        this.ruleForm.jielongGoodsRuleModelList.push(...data);
        this.ruleForm.jielongGoodsRuleModelList = arrayUnique2(
          this.ruleForm.jielongGoodsRuleModelList,
          "wxshopSkuId"
        );
      } else {
        this.$message({
          message: "请选择商品",
          type: "warning"
        });
      }
    },
    setLink(row) {
      this.dialogVisible = false;
      this.isRadio = false;
    },
    deleteGoodChild(index, row) {
      this.ruleForm.jielongGoodsRuleModelList.splice(index, 1);
    },
    async queryTag() {
      const { result } = await this.$store.dispatch("findJieLongTag");
      let arr = [];
      result.map(item => {
        arr.push(item.labelValue);
      });
      this.ruleForm.activityLabels = arr.slice(0, 3);
    },
    showInput() {
      this.inputVisible = true;
      this.$nextTick(() => {
        this.$refs.saveTagInput.$refs.input.focus();
      });
    },
    handleClose(tag) {
      console.log("tag---handleClose", tag);
      this.ruleForm.activityLabels.splice(
        this.ruleForm.activityLabels.indexOf(tag),
        1
      );
    },
    handleInputConfirm() {
      console.log("length", this.ruleForm.activityLabels.length);
      if (this.ruleForm.activityLabels.length > 4) {
        this.$message({
          message: "最多只能添加5个标签",
          type: "warning"
        });
        return false;
      }
      let inputValue = this.inputValue;
      if (inputValue) {
        this.ruleForm.activityLabels.push(inputValue);
        const { result } = this.$store.dispatch("addJieLongTag", {
          labelValue: inputValue
        });
        console.log("result---", result);
      }
      this.inputVisible = false;
      this.inputValue = "";
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          let params = JSON.parse(JSON.stringify(this.ruleForm));
          console.log("params--1111", params);
          params.commissionState = this.commissionState;
          params.gameStartTime =
            this.ruleForm.activityDate && this.ruleForm.activityDate.length > 0
              ? this.ruleForm.activityDate[0]
              : "";
          params.gameEndTime =
            this.ruleForm.activityDate && this.ruleForm.activityDate.length > 0
              ? this.ruleForm.activityDate[1]
              : "";
          if (this.$refs.hmform) {
            this.columnsInfoModels = this.$refs.hmform.list;
          }
          if (this.ruleForm.expressModeGroups.length < 1) {
            this.$message({
              message: "请选择配送方式",
              type: "warning"
            });
            return false;
          }
          if(this.ruleForm.usePromotion === 'yes' && this.jielongFullReductionRuleModelList.length < 1){
             this.$message({
              message: "请添加优惠方式",
              type: "warning"
            });
            return false;
          }
          params.gameType = "jielong";
          params.gameId = this.gameId;
          params.updateMode = this.updateMode;
          params.columnsInfoModels = this.columnsInfoModels;
          params.gameBgp = this.listHeaderImgUrl;
          params.gameBgp2 = this.ruleForm.sharePic;
          if(this.ruleForm.usePromotion === 'yes'){
            params.jielongFullReductionRuleModelList = this.jielongFullReductionRuleModelList;
            params.gameVersion = this.gameVersion;
          }
          console.log("params:",params);
          // return false;
          if (this.changeTeam) {
            console.log("修改---");
            // 修改
            this.$store.dispatch("editGameInfoJieLong", params).then(res => {
              if (res.code === "0") {
                this.$message({
                  message: "操作成功",
                  type: "success"
                });
                this.$router.back(-1);
              }
            });
          } else {
            // 新增和复制
            console.log("新增");
            this.$store.dispatch("saveGameInfoJieLong", params).then(res => {
              if (res.code === "0") {
                this.$message({
                  message: "操作成功",
                  type: "success"
                });
                this.$router.back(-1);
              }
            });
          }
        } else {
          return false;
          // this.$message({
          //   message: "操作失败",
          //   type: "fail",
          // });
          // // this.$router.back(-1);
        }
      });
    },
    uploadSharePicSucc(jsonData){
      if (jsonData.code === 0) {
        this.ruleForm.sharePic = jsonData.result;
        this.uploadShow = false;
      }
    },
    beforeUpload(file) {
      const extension =
        file.name.slice(file.name.lastIndexOf(".") + 1).toLowerCase() ===
          "jpg" ||
        file.name.slice(file.name.lastIndexOf(".") + 1).toLowerCase() === "gif";
      const extension2 =
        file.name.slice(file.name.lastIndexOf(".") + 1).toLowerCase() ===
        "jpeg";
      const extension3 =
        file.name.slice(file.name.lastIndexOf(".") + 1).toLowerCase() === "png";
      const extension4 =
        file.name.slice(file.name.lastIndexOf(".") + 1).toLowerCase() === "bmp";
      // file.size单位为b，除以1024得到kb
      const limitSize = file.size / 1024 <= 1020;
      if (!extension && !extension2 && !extension3 && !extension4) {
        this.$message({
          message: "上传模板只能是 jpg、jpeg、png、bmp格式!",
          type: "warning"
        });
      }
      if (!limitSize) {
        this.$message({
          message: "上传模板大小不能超过 1M!",
          type: "warning"
        });
      }
      return (extension || extension2 || extension3 || extension4) && limitSize;
    },
    // 正在上传
    uploading() {
      this.isSaving = true;
      this.uploadShow = true;
    },
    handleRemoveSharePic(){
      this.ruleForm.sharePic = "";
    },
    cropSuccess() {},
    cropUploadFail() {},
    cropUploadSuccess(jsonData) {
      if (this.show) {
        this.listHeaderImgUrl = jsonData.result;
      }
    },
    toggleShow() {
      this.show = !this.show;
    },
    addItem(list) {
      let totalLimit = 0;
      this.increasePurchaseResult.map(v => {
        totalLimit += v.selectUpperLimit;
      });
      switch (list) {
        // 满送
        case "fullDelivery":
          if (!this.purchasesAmount) {
            this.$message({
              type: "error",
              message: "请输入门槛金额"
            });
          } else if (!+this.chooseDeliveryAmount) {
            this.$message({
              type: "error",
              message: "请输入可选商品数量"
            });
          } else if (!this.fullDeliveryResult.length) {
            this.$message({
              type: "error",
              message: "请添加商品"
            });
          } else {
            const groupFlag = this.fullDeliveryGoods.length
              ? this.fullDeliveryGoods.length
              : 0;
            this.fullDeliveryGoods.push({
              groupGoods: JSON.parse(JSON.stringify(this.fullDeliveryResult)),
              giftLimit: this.giftLimit,
              groupFlag,
              selectLowerLimit: +this.chooseDeliveryAmount
            });
          }
          this.selectedFullDeliveryGoods = [];
          break;
          // 满减
          case "jielongFullReductionRuleModelList":
            if (
              +this.discountResult > +this.calcCondition &&
              this.childId === "PriceReduction"
            ) {
              this.$message({
                type: "error",
                message: "满减金额不能大于门槛金额"
              });
            } else if (
              this[list].find(v => +v.calcCondition >= +this.calcCondition)
            ) {
              this.$message({
                type: "error",
                message: "添加门槛金额应大于已有门槛"
              });
            } else if (!this.discountResult || !this.calcCondition) {
              this.$message({
                type: "error",
                message: "请输入门槛金额和优惠金额"
              });
            } else {
              if (this.cyclesTimes > 0) {
                this[list].forEach(v => (v.cyclesTimes = 0));
              }
              this[list].push({
                calcCondition: this.calcCondition,
                discountResult: this.discountResult,
                cyclesTimes: this.cyclesTimes
              });
            }
            break;
          // 满折
          case "fullDiscountRule":
            if (
              this[list].find(v => +v.purchasesAmount == +this.purchasesAmount)
            ) {
              this.$message({
                type: "error",
                message: "添加件数不能等于已有件数！"
              });
            } else if (!this.purchasesAmount || !this.discountRatio) {
              this.$message({
                type: "error",
                message: "请输入件数和折扣！"
              });
            } else if (this.discountRatio > 10) {
              this.$message({
                type: "error",
                message: "折扣限制为10以内的数！"
              });
            } else {
              this[list].push({
                purchasesAmount: this.purchasesAmount,
                discountRatio: this.discountRatio
              });
            }
            break;
          // 加价购
          case "increasePurchaseRules":
            this.markupFee = new Number(this.markupFee);
            if (!this.purchasesAmount || !this.markupFee) {
              this.$message({
                type: "error",
                message: "请添加门槛与加价"
              });
            } else if (this.markupFee == 0) {
              this.$message({
                type: "error",
                message: "加价金额不能为0"
              });
            } else if (!this.increasePurchaseResult.length) {
              this.$message({
                type: "error",
                message: "请添加商品"
              });
            } else if (!this.exchangePurchasesUpperAmount) {
              this.$message({
                type: "error",
                message: "请添加换购件数"
              });
            } else if (
              this[list].find(v => +v.purchasesAmount == +this.purchasesAmount)
            ) {
              this.$message({
                type: "error",
                message: "添加门槛不能等于已有门槛！"
              });
            } else if (+this.exchangePurchasesUpperAmount > totalLimit) {
              this.$message({
                type: "error",
                message: "换购件数应小于或等于商品换购列表上限之和！"
              });
            } else {
              this.increasePurchaseRules.push({
                markupFee: this.markupFee,
                purchasesAmount: this.purchasesAmount,
                exchangePurchasesUpperAmount: this.exchangePurchasesUpperAmount,
                purchaseGoodsList: JSON.parse(
                  JSON.stringify(this.increasePurchaseResult)
                )
              });
            }
            break;
          case "combinationPriceRules":
            if (!this.purchasesAmount || !this.combinationPrice) {
              this.$message({
                type: "error",
                message: "请添加门槛与组合价，组合价不能为0"
              });
            } else if (
              this[list].find(v => +v.purchasesAmount == +this.purchasesAmount)
            ) {
              this.$message({
                type: "error",
                message: "添加门槛不能等于已有门槛！"
              });
            } else {
              this.combinationPriceRules.push({
                combinationPrice: this.combinationPrice,
                purchasesAmount: this.purchasesAmount
              });
            }
            break;
          default:
            break;
      }
    },
    // 过滤大于0且如果是小数保留两位
    filterGt0OrFixed2(prop) {
      // this[prop] = this[prop].replace(/^(0+)/, ""); //过滤0开头
      this[prop] = this[prop].replace(/[^\d.]/g, ""); //仅保留数字和"."
      this[prop] = this[prop].replace(/\.{2,}/g, "."); //两个连续的"."仅保留第一个"."
      this[prop] = this[prop]
        .replace(".", "$#*")
        .replace(/\./g, "")
        .replace("$#*", "."); //去除其他"."
      this[prop] = this[prop].replace(/^(\d+)\.(\d\d).*$/, "$1.$2"); //限制只能输入两个小数
      if (this[prop].indexOf(".") < 0 && this[prop] != "") {
        //首位是0的话去掉
        this[prop] = parseFloat(this[prop]);
      }
    },
    deleteItem(list, i) {
      this[list].splice(i, 1);
    },
    async getParamValueAllowNull() {
      console.log("getParamValueAllowNull");
      const { code ,result } = await this.$store.dispatch("getParamValueAllowNull", {
        paramCode: "jielong_allow_promotion"
      })
      if (code === "0") {
        console.log("result.paramValue",result.paramValue)
        if(result.paramValue && result.paramValue === "yes"){
          this.isShowPromotion = true;
        }
      }
    },
  }
};
</script>

<style scoped lang="scss">
.lt_bg {
  background-image: url("/src/assets/jielong.png");
}
.preview-container {
  .act-info-wrapper {
    margin-bottom: 20px;
  }
  .act-info-goods {
    // background: #fff;
    padding: 10px 0;
    height: 360px;
    font-size: 13px;
    .radio {
      width: 20px;
      height: 20px;
      border: 1px solid #cccccc;
      border-radius: 50%;
    }
    .goods-name {
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      overflow: hidden;
    }
  }
  .second-tabs {
    background: #f5f5f5;
    .second-tab {
      width: 80px;
      height: 60px;
      &.active {
        background: #fff;
        color: #f72b2b;
        border: none;
        position: relative;
        font-weight: 600;
        .area-num {
          color: #999;
        }
      }
      .area-name {
        text-align: center;
        font-size: 15px;
      }
      .area-num {
        text-align: center;
        font-size: 12px;
      }
    }
  }
}
.upload-upload-btn {
  .tips {
    color: #999;
    font-size: 12px;
    line-height: 20px;
  }

  .btn {
    border: 1px solid #ddd;
    text-align: center;
    margin-left: 0;
    // padding: 10px;
    margin-right: 10px;
    width: 400px;
    height: 150px;
    cursor: pointer;
    .add-wrapper {
      width: 30px;
      height: 30px;
      line-height: 30px;
      background: #e50065;
      color: #fff;
      text-align: center;
      border-radius: 50%;
      margin: 0 auto;
      span {
        font-size: 12px;
      }
      cursor: pointer;
      .hmicon {
        font-size: 14px;
      }
    }
  }
}

.priview {
  position: relative;
  width: 400px;
  height: 150px;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  margin: 10px;
  .img {
    width: 100%;
    height: 100%;
  }
  img {
    width: 100%;
    height: 100%;
  }
  .opreat-wrapper {
    transition: opacity 0.2s linear;
    position: absolute;
    opacity: 0;
    top: 0;
    left: 0;
    right: 0;
    // bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    border-radius: 6px;
  }

  &:hover {
    .opreat-wrapper {
      opacity: 1;
    }
  }
}

.add-goods-container {
  width: 1128px;
  flex-shrink: 0;
}
.slot {
  position: relative;
  background-size: 100% 100%;
  height: 100%;
  &:hover {
    .change-bg {
      display: block;
    }
  }
  .header-img-wrapper {
    box-sizing: border-box;
    height: 150px;
    .header-img {
      width: 100%;
      height: 100%;
      display: block;
    }
  }
  .bottom {
    background: #fff;
    padding: 5px 10px;
    .cart {
      margin-top: -30px;
      z-index: 111;
      background: #fff;
      padding: 15px 5px;
      border-radius: 50%;
      img {
        width: 50px;
        height: 37px;
      }
    }
    .submit {
      width: 110px;
      height: 30px;
      line-height: 30px;
      background: #999999;
      border-radius: 38px;
      text-align: center;
      opacity: 0.5;
      color: #fff;
    }
  }

  .tabs {
    background: #fff;

    .tab {
      color: #000;
      box-sizing: border-box;
      height: 34px;
      line-height: 34px;
      width: 174px;
      text-align: center;

      &.active {
        background: #fff;
        color: #f72b2b;
        border: none;
        position: relative;
        font-weight: 600;
        &::after {
          position: absolute;
          bottom: 0;
          left: 50%;
          content: "";
          width: 50px;
          height: 3px;
          transform: translateX(-50%);
          background: #f72b2b;
          border-radius: 3px;
        }
      }
    }
  }
  .title-img {
    position: absolute;
    left: 50%;
    top: 57px;
    transform: translateX(-50%);
    img {
      width: 259px;
    }
  }
  .change-bg {
    position: absolute;
    top: 60px;
    right: 0;
    height: 34px;
    font-size: 12px;
    background-color: rgba(0, 0, 0, 0.8);
    border: 1px solid #fff;
    border-radius: 4px;
    text-align: center;
    line-height: 34px;
    color: #fff;
    z-index: 10;
    padding: 0 10px;
    display: none;
  }
  .card-back {
    position: absolute;
    left: 50%;
    top: 128px;
    transform: translateX(-50%);
    &:hover {
      .switch-card-bg {
        display: block;
      }
    }
    .normarl-card-back,
    .fusion-cad-back {
      img {
        width: 240px;
      }
    }
    .switch-card-bg {
      position: absolute;
      left: 36px;
      top: 0;
    }
  }
  .card-list-wrapper {
    position: absolute;
    top: 468px;
    left: 15px;
    right: 15px;
    .card-list {
      overflow-x: auto;
      .card-item {
        flex-shrink: 0;
        margin-right: 15px;
      }
      .single-card {
        width: 72px;
        height: 96px;
        background-size: 100% 100%;
      }
      .card-name {
        height: 18px;
        font-size: 14px;
        color: #fff;
        text-align: center;
        .ipt {
          background: transparent;
          color: #fff;
          text-align: center;
          font-size: 12px;
          border: none;
          outline: none;
          width: 72px;
        }
      }
    }
  }
  .phone-btn-wrapper {
    position: absolute;
    top: 600px;
    left: 0;
    right: 0;
    .get-card,
    .do-task {
      border: none;
    }
    .get-card {
      width: 210px;
      height: 43px;
      line-height: 43px;
      background-size: 100% 100%;
      font-size: 18px;
      font-weight: bold;
      color: #f82c2c;
      text-align: center;
    }
    .do-task {
      width: 105px;
      height: 43px;
      background-size: 100% 100%;
      text-align: center;
      .title {
        font-size: 16px;
        color: #fff;
      }
      .tips {
        font-size: 12px;
        color: #ffc66e;
      }
    }
  }
}

.button-new-tag {
  margin-left: 10px;
  height: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
}
.input-new-tag {
  width: 90px;
  margin-left: 10px;
  vertical-align: bottom;
}
.priview {
  position: relative;
  width: 375px;
  height: 178px;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  img {
    width: 100%;
    height: 100%;
  }
  .opreat-wrapper {
    transition: opacity 0.2s linear;
    position: absolute;
    opacity: 0;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    border-radius: 6px;
  }

  &:hover {
    .opreat-wrapper {
      opacity: 1;
    }
  }
}

.preview-wrapper {
  position: fixed;
  top: 100px;
  right: 30px;
  width: 365px;
  z-index: 10;
}

.event-details-table {
  border: 1px solid #f0f0f0;
  border-radius: 5px;
  .table-header {
    background: #f7f7f7;
    padding: 0 10px;
    .title {
      text-align: center;
    }
  }
  .activity-item {
    padding: 0 10px;
    .ipt-wrapper {
      box-sizing: border-box;
      .el-input {
        width: 80%;
      }
    }
  }
}

.location-item:not(:last-child) {
  margin-bottom: 20px;
}

.actCostMoney {
  padding-left: 20px;
  .tip {
    color: #999;
  }
}

.event-adress {
  margin-bottom: 10px;
}

.act-container {
  max-width: 2000px;
  overflow-x: auto;
  .step-wrapper {
    border-bottom: none !important;
    margin-bottom: 0;
  }
  .bg {
    height: 80px;
    background: linear-gradient(to bottom, #f73030, #f6c0c0, #f5f5f5);
    z-index: -1;
  }
  .add-goods-container {
    width: 1128px;
    flex-shrink: 0;
  }
  .slot {
    position: relative;
    background-size: 100% 100%;
    height: 100%;
    &:hover {
      .change-bg {
        display: block;
      }
    }
    .header-img-wrapper {
      box-sizing: border-box;
      height: 150px;
      .header-img {
        width: 100%;
        height: 100%;
        display: block;
      }
    }
    .bottom {
      background: #fff;
      padding: 5px 10px;
      .cart {
        margin-top: -30px;
        z-index: 111;
        background: #fff;
        padding: 15px 5px;
        border-radius: 50%;
        img {
          width: 50px;
          height: 37px;
        }
      }
      .submit {
        width: 110px;
        height: 30px;
        line-height: 30px;
        background: #999999;
        border-radius: 38px;
        text-align: center;
        opacity: 0.5;
        color: #fff;
      }
    }

    .tabs {
      background: #fff;

      .tab {
        color: #000;
        box-sizing: border-box;
        height: 34px;
        line-height: 34px;
        width: 174px;
        text-align: center;

        &.active {
          background: #fff;
          color: #f72b2b;
          border: none;
          position: relative;
          font-weight: 600;
          &::after {
            position: absolute;
            bottom: 0;
            left: 50%;
            content: "";
            width: 50px;
            height: 3px;
            transform: translateX(-50%);
            background: #f72b2b;
            border-radius: 3px;
          }
        }
      }
    }
    .title-img {
      position: absolute;
      left: 50%;
      top: 57px;
      transform: translateX(-50%);
      img {
        width: 259px;
      }
    }
    .change-bg {
      position: absolute;
      top: 60px;
      right: 0;
      height: 34px;
      font-size: 12px;
      background-color: rgba(0, 0, 0, 0.8);
      border: 1px solid #fff;
      border-radius: 4px;
      text-align: center;
      line-height: 34px;
      color: #fff;
      z-index: 10;
      padding: 0 10px;
      display: none;
    }
    .card-back {
      position: absolute;
      left: 50%;
      top: 128px;
      transform: translateX(-50%);
      &:hover {
        .switch-card-bg {
          display: block;
        }
      }
      .normarl-card-back,
      .fusion-cad-back {
        img {
          width: 240px;
        }
      }
      .switch-card-bg {
        position: absolute;
        left: 36px;
        top: 0;
      }
    }
    .card-list-wrapper {
      position: absolute;
      top: 468px;
      left: 15px;
      right: 15px;
      .card-list {
        overflow-x: auto;
        .card-item {
          flex-shrink: 0;
          margin-right: 15px;
        }
        .single-card {
          width: 72px;
          height: 96px;
          background-size: 100% 100%;
        }
        .card-name {
          height: 18px;
          font-size: 14px;
          color: #fff;
          text-align: center;
          .ipt {
            background: transparent;
            color: #fff;
            text-align: center;
            font-size: 12px;
            border: none;
            outline: none;
            width: 72px;
          }
        }
      }
    }
    .phone-btn-wrapper {
      position: absolute;
      top: 600px;
      left: 0;
      right: 0;
      .get-card,
      .do-task {
        border: none;
      }
      .get-card {
        width: 210px;
        height: 43px;
        line-height: 43px;
        background-size: 100% 100%;
        font-size: 18px;
        font-weight: bold;
        color: #f82c2c;
        text-align: center;
      }
      .do-task {
        width: 105px;
        height: 43px;
        background-size: 100% 100%;
        text-align: center;
        .title {
          font-size: 16px;
          color: #fff;
        }
        .tips {
          font-size: 12px;
          color: #ffc66e;
        }
      }
    }
  }

  .details-container {
    .price {
      color: #f72b2b;
    }

    .concat-us-wrapper {
      position: fixed;
      right: 0;
      bottom: 100px;
      z-index: 999;
      height: 26px;
      line-height: 26px;
      border-radius: 30px 0 0 30px;
      background: rgba(0, 0, 0, 0.5);
      color: #fff;
      text-align: center;
      padding: 5px 10px;
      .contact-button {
        background: transparent;
        line-height: 26px;
        color: #fff;
        font-size: 12px;
        height: 100%;
        display: block;
      }
    }
    .banner {
      .upload-img {
        top: 60px;
      }
    }

    .card {
      position: relative;
      margin: 0;
      background: #fff;
      padding: 15px;
      line-height: 30px;
      font-size: 13px;
      .share {
        width: 85px;
        height: 85px;
        position: absolute;
        top: -42px;
        right: 0;
        background: transparent;
        padding: 0;
        margin: 0;
        z-index: 9999;

        img {
          width: 100%;
        }
      }
      .price-box {
        font-size: 18px;
        font-weight: bold;
        margin-right: 10px;
      }
      .time-and-address {
        background: #f5f5f5;
        padding: 10px;
        border-radius: 5px;
        margin: 15px 0;
        font-size: 12px;
        .item {
          &::before {
            display: inline-block;
            width: 5px;
            height: 5px;
            background: #656565;
            border-radius: 50%;
            margin-right: 8px;
            content: "";
          }
        }
      }

      .detail {
        font-size: 13px;

        &::before {
          content: "";
          display: inline-block;
          border-radius: 50%;
          width: 5px;
          height: 5px;
          margin-right: 5px;
          background: #666666;
        }
      }
    }

    .avatar-list {
      .image {
        width: 29px;
        height: 29px;
        border-radius: 50%;
        border: 1px solid #fff;
        margin: -4px;
      }
    }
    .activity-name {
      margin: 0;
    }

    .for-people {
      height: 16px;
      line-height: 16px;
      background: #ededed;
      border-radius: 3px;
      font-size: 11px;
      color: #656565;
      padding: 3px 5px;
    }

    .rich-text-container {
      margin: 15px 0 60px;
      background: #fff;

      .rich-text-header {
        padding: 20px;

        .line {
          background: #f72b2b;
          width: 20px;
          height: 3px;
          border-radius: 30px;

          &::after {
            display: block;
            content: "";
            background: #f72b2b;
            width: 20px;
            height: 3px;
            border-radius: 30px;
            transform: translate(5px, 5px);
          }
        }

        .caption {
          margin: 0 15px;
          font-size: 16px;
          font-weight: bold;
        }
      }
      .rich-text {
        padding: 10px;
      }
    }

    .apply-wrapper {
      margin: 15px 0;
      font-size: 16px;
      font-weight: bold;
    }
    .time {
      white-space: nowrap;
      // span {
      //   transform: scale(0.8);
      // }
    }
  }
}
.priviewSharePic{
  width: 250px;
  height: 200px;
}
.caption {
  position: relative;
  // padding-left: 10px;
  color: #000;
  // margin-bottom: 20px;
  // &::before {
  //   position: absolute;
  //   left: 0;
  //   width: 4px;
  //   height: 100%;
  //   background: #e50065;
  //   content: "";
  //   border-top-left-radius: 5px;
  //   border-bottom-right-radius: 5px;
  // }
}
.way {
  .way-item {
    .el-select {
      .el-input {
        width: 80px;
        .el-input__inner {
          border: none;
          border-bottom: 1px solid #dcdfe6;
          border-radius: 0;
          padding: 0;
          text-align: center;
        }
      }
    }
    .item {
      .el-input {
        width: 60px;
        .el-input__inner {
          border: none;
          border-bottom: 1px solid #dcdfe6;
          border-radius: 0;
          padding: 0;
          text-align: center;
        }
      }
    }
  }
  .panel {
    .el-input__inner {
      background: transparent;
    }
  }
}
.way {
  margin-top: 20px;
  font-size: 14px;
  .title {
    height: 40px;
    line-height: 40px;
    margin-right: 40px;
  }

  .way-item {
    margin-bottom: 20px;
    .content {
      padding-top: 12px;
    }
  }
}
</style>
